import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router";

import { FcShop } from "react-icons/fc";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import Footer from "../../Components/Footer/footer";
import { CreateFarmerOrder } from "../../Schemas/Farm support/farmer_shop_schema";
import { CnFShopInfo } from "../../SchemaInfo/info";
import { Form, Formik } from "formik";
import CustomInput from "../../CustomComponent/custom_input";
import CustomTextArea from "../../CustomComponent/custom_textarea";
import { IoMdAdd } from "react-icons/io";
import CustomSelect from "../../CustomComponent/custom_select";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import { roundOffCost } from "../../Components/Functions/amt.fun";

const CnfShop = () => {
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [plantData, setplantData] = useState();
  const [buttonToogle, setbuttonToogle] = useState(false);
  const [addressData, setAddressData] = useState();
  const [city, setCity] = useState();
  const [filters, setFilters] = useState({
    sortByPrice: "",
    category: "",
  });
  const [getaccFiltered, setAccFiltered] = useState(false);
  const [getPlantsFiltered, setPlantsFiltered] = useState(false);
  const [project, setProjects] = useState();

  const handleOrderPlants = (item) => {
    performRequest(
      "POST",
      "/pmg/cf-orders/all-fa-listwithinventoryavailabitity",
      item
    )
      .then((res) => {
        if (res.status === 200) {
          setProjects(res?.data?.data);
        }
      })
      .catch((err) => {
        console.error("Error submitting order", err);
      });
  };

  useEffect(() => {
    performRequest("GET", "/pmg/cities/all-cities")
      .then((res) => {
        if (res.status === 201) {
          setCity(res?.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/pmg/accessories/all-accessories", 1, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [getaccFiltered]);

  useEffect(() => {
    performRequest("GET", getFilteredURL("/pmg/plants/all-plants", 1, filters))
      .then((res) => {
        if (res.status === 200) {
          setplantData(res.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [getPlantsFiltered]);

  useEffect(() => {
    performRequest("GET", "/pmg/address/all-address")
      .then((res) => {
        if (res.status === 200) {
          setAddressData(res.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const handelSubmit = async (values) => {
    if (values.accId) {
      values = { ...values, orderType: "cnf to kryzen" };
    }
    if (values.plantId) {
      values = { ...values, orderType: "cnf to farmer" };
    }
    performRequest("POST", "/pmg/cf-orders/create-cf-order", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Item ordered successfully!");
          navigate("/farm-cnf-order");
        } else {
          Toast("error", "Error while creating order!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  const handelSubmitAddress = async (values) => {
    performRequest("POST", "/pmg/address/create-address", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Address added successfully!");
          navigate("/farm-cnf-order");
        } else {
          Toast("error", "Error while creating order!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };
  const handelfilter = () => {
    if (filters.category === "accessories") {
      setbuttonToogle(false);
      setAccFiltered(!getaccFiltered);
    } else if (filters.category === "plants") {
      setbuttonToogle(true);
      setPlantsFiltered(!getPlantsFiltered);
    } else if (filters.sortByPrice === "asc" && buttonToogle === true) {
      setPlantsFiltered(!getPlantsFiltered);
    } else if (filters.sortByPrice === "asc" && buttonToogle === false) {
      setAccFiltered(!getaccFiltered);
    } else if (filters.sortByPrice === "desc" && buttonToogle === true) {
      setPlantsFiltered(!getPlantsFiltered);
    } else if (filters.sortByPrice === "desc" && buttonToogle === false) {
      setAccFiltered(!getaccFiltered);
    } else if (buttonToogle === false) {
      setAccFiltered(!getaccFiltered);
    } else {
      setPlantsFiltered(!getPlantsFiltered);
    }
  };
  const handleOrderPlant = async (values) => {
    if (values.accId) {
      values = { ...values, orderType: "cnf to kryzen" };
    }
    if (values.productId) {
      values = { ...values, orderType: "cnf to farmer" };
    }
    performRequest("POST", "/pmg/cf-orders/create-cf-order", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Item ordered successfully!");
          navigate("/farm-cnf-order");
        } else {
          Toast("error", "Error while creating order!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };
  const handleQuantityChange = (value, setFieldValue, price) => {
    setFieldValue("quantity", value);
    setFieldValue("totalAmount", value * price);
  };

  const handleCityChange = (cityName, setFieldValue) => {
    const selectedCity = city?.allCityData?.find((c) => c.city === cityName);
    if (selectedCity) {
      setFieldValue("shippingAddress.city", selectedCity.city);
      setFieldValue("shippingAddress.pincode", selectedCity.pincode);
      setFieldValue("shippingAddress.state", selectedCity.state);
    }
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-fluid">
          <div className="page-header d-print-none m-0">
            <div className="row align-items-center d-flex">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcShop className="fs-2  me-1" />
                  CnF Shop
                </h2>
                <h4 className="text-muted p-0 m-0">Order items from shop.</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className="accordion-body pt-0">
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Price:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  sortByPrice: e.target.value,
                                })
                              }
                              value={filters.sortByPrice}
                            >
                              <option value="">Select</option>
                              <option value="asc">Low to high</option>
                              <option value="desc">High to low</option>
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Select category:"
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  category: e.target.value,
                                })
                              }
                              value={filters.category}
                            >
                              <option value="">Select</option>
                              <option value="accessories">Accessories</option>
                              <option value="plants">Plants</option>
                            </DynamicFilterSelect>
                          </div>
                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => handelfilter()}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      category: "",
                                      sortByPrice: "",
                                    });
                                    handelfilter();
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Price:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                sortByPrice: e.target.value,
                              })
                            }
                            value={filters.sortByPrice}
                          >
                            <option value="">Select</option>
                            <option value="asc">Low to high</option>
                            <option value="desc">High to low</option>
                          </DynamicFilterSelect>
                        </div>

                        <div className="col-12">
                          <DynamicFilterSelect
                            label="Select category:"
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                category: e.target.value,
                              })
                            }
                            value={filters.category}
                          >
                            <option value="">Select</option>
                            <option value="plants">Plants</option>
                            <option value="accessories">Accessories</option>
                          </DynamicFilterSelect>
                        </div>
                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => handelfilter()}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    category: "",
                                    sortByPrice: "",
                                  });
                                  handelfilter();
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-9 col-sm-12 py-2">
              {!buttonToogle ? (
                <div className="row row-deck">
                  {data?.map((item) => (
                    <div className="col-md-4 col-6 mb-4" key={item?.id}>
                      <div className="card h-100 d-flex flex-column">
                        <div className="text-center mt-3">
                          <img
                            src={item?.photo}
                            className="me-3"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                            }}
                            alt="Item"
                          />
                          <p className="ms-2 me-2 mb-0 mt-2">{item?.name}</p>
                        </div>
                        <div className="card-body d-flex flex-column mt-0">
                          <b className="text-bold mb-2 fs-3 text-center">
                            Price per unit :{" "}
                            <span style={{ color: "rgb(12, 131, 31)" }}>
                              ₹{item?.price}
                            </span>
                          </b>
                          <p className="mb-1 text-center">MOQ : {item?.moq}</p>
                          <p className="mb-1 text-center">
                            Price per MOQ : ₹{item?.pricePerMoq}
                          </p>
                          <div className="mt-auto">
                            <button
                              className="btn w-100 btn-success mt-2"
                              style={{
                                borderRadius: "8px",
                                fontWeight: "bold",
                                fontSize: "16px",
                              }}
                              data-bs-toggle="modal"
                              data-bs-target={`#modal-${item.id}`}
                            >
                              Order Now
                            </button>
                          </div>
                          {/* Modal */}
                          <div
                            className="modal modal-blur fade"
                            id={`modal-${item.id}`}
                            tabIndex="-1"
                            role="dialog"
                            aria-hidden="true"
                          >
                            <Formik
                              initialValues={{
                                ...CnFShopInfo,
                                accId: item.id,
                                productId: null,
                                orderTo: 1,
                              }}
                              validationSchema={CreateFarmerOrder}
                              onSubmit={handelSubmit}
                              enableReinitialize
                            >
                              {(props) => (
                                <Form className="modal-dialog modal-dialog-centered w-lg-100 w-md-100">
                                  <div
                                    className="modal-dialog modal-dialog-centered w-100"
                                    role="document"
                                  >
                                    <div className="modal-content">
                                      <div className="modal-header">
                                        <h5 className="modal-title">Order</h5>
                                        <button
                                          type="button"
                                          className="btn-close"
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                        ></button>
                                      </div>
                                      <div className="modal-body">
                                        {/* Quantity */}
                                        <div className="mb-3 row d-flex">
                                          <div className="w-50">
                                            <label className="form-label required">
                                              Quantity
                                            </label>
                                            <div className="w-100 col">
                                              <CustomInput
                                                name="quantity"
                                                type="text"
                                                onChange={(e) =>
                                                  handleQuantityChange(
                                                    e.target.value,
                                                    props.setFieldValue,
                                                    item.price
                                                  )
                                                }
                                              />
                                              {props.touched.quantity &&
                                                props.errors.quantity && (
                                                  <p className="text-danger">
                                                    {props.errors.quantity}
                                                  </p>
                                                )}
                                            </div>
                                          </div>
                                          <div className="w-50">
                                            <label className="form-label required">
                                              Total Amount
                                            </label>
                                            <div className="ms-2 mt-2">
                                              ₹{props.values.totalAmount}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="mb-3 row">
                                          <label className="form-label required">
                                            Select order to
                                          </label>
                                          <div className="w-100 col">
                                            <CustomSelect
                                              name="orderTo"
                                              type="text"
                                              className="form-control"
                                            >
                                              <option value="">Select</option>
                                              <option value={1}>Kryzen</option>
                                            </CustomSelect>
                                            {props.touched.orderTo &&
                                              props.errors.orderTo && (
                                                <p className="text-danger">
                                                  {props.errors.orderTo}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                        <div className="row w-100 d-flex">
                                          <div className="mb-3 w-50">
                                            <label className="form-label required">
                                              Select Address
                                            </label>
                                            <select
                                              className="form-select"
                                              onChange={(e) => {
                                                const selectedAddress =
                                                  addressData.find(
                                                    (addr) =>
                                                      addr.id ===
                                                      parseInt(e.target.value)
                                                  );
                                                if (selectedAddress) {
                                                  // Set the form fields using Formik's setFieldValue
                                                  props.setFieldValue(
                                                    "shippingAddress",
                                                    selectedAddress.shippingAddress
                                                  );
                                                }
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select an address"
                                              />
                                              {addressData?.map((address) => (
                                                <option
                                                  key={address.id}
                                                  value={address.id}
                                                >
                                                  {
                                                    address.shippingAddress
                                                      .address
                                                  }
                                                  ,{" "}
                                                  {address.shippingAddress.city}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                          <div className="mb-3 w-50 mt-4">
                                            <button
                                              className="btn btn-primary ms-5"
                                              data-bs-dismiss="modal"
                                              onClick={() =>
                                                navigate("/add-address")
                                              }
                                            >
                                              <IoMdAdd className="me-2" /> Add
                                              Address
                                            </button>
                                            {/* <div
                                              className="modal modal-blur fade"
                                              id="modal-address"
                                              tabindex="-1"
                                              role="dialog"
                                              aria-hidden="true"
                                            >
                                              <div
                                                className="modal-dialog modal-dialog-centered"
                                                role="document"
                                              >
                                                <div className="modal-content">
                                                  <div className="modal-header">
                                                    <h5 className="modal-title">
                                                      Add a new address
                                                    </h5>
                                                    <button
                                                      type="button"
                                                      className="btn-close"
                                                      data-bs-dismiss="modal"
                                                      aria-label="Close"
                                                    ></button>
                                                  </div>
                                                  <div className="modal-body">
                                                    <div className="row mb-3 align-items-end">
                                                      <div className="col">
                                                        <label className="form-label">
                                                          Name
                                                        </label>
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="modal-footer">
                                                    <button
                                                      type="button"
                                                      className="btn me-auto"
                                                      data-bs-dismiss="modal"
                                                    >
                                                      Close
                                                    </button>
                                                    <button
                                                      type="button"
                                                      className="btn btn-primary"
                                                      data-bs-dismiss="modal"
                                                    >
                                                      Add Team
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div> */}
                                          </div>
                                        </div>

                                        {/* Address */}
                                        <div className="mb-3 row">
                                          <label className="form-label required">
                                            Address
                                          </label>
                                          <CustomTextArea
                                            name="shippingAddress.address"
                                            type="text"
                                          />
                                        </div>
                                        {/* Address  */}
                                        <div className="mb-3 row">
                                          <label className="form-label required">
                                            Select City
                                          </label>
                                          <select
                                            name="shippingAddress.city"
                                            className="form-select"
                                            value={
                                              props.values.shippingAddress.city
                                            }
                                            onChange={(e) => {
                                              handleCityChange(
                                                e.target.value,
                                                props.setFieldValue
                                              );
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select city"
                                            />
                                            {city?.allCityData?.map((item) => (
                                              <option
                                                key={item.id}
                                                value={item.city}
                                              >
                                                {item.city}
                                              </option>
                                            ))}
                                          </select>
                                          {props.errors.shippingAddress
                                            ?.city && (
                                            <p className="text-danger">
                                              {
                                                props.errors.shippingAddress
                                                  .city
                                              }
                                            </p>
                                          )}
                                        </div>

                                        {/* Pincode */}
                                        <div className="mb-3 row w-100 d-flex">
                                          <div className="mb-3 w-50">
                                            <label className="form-label required">
                                              Pincode
                                            </label>
                                            <CustomInput
                                              name="shippingAddress.pincode"
                                              type="text"
                                            />
                                          </div>
                                          <div className="mb-3 w-50">
                                            <label className="form-label required">
                                              State
                                            </label>
                                            <CustomInput
                                              name="shippingAddress.state"
                                              type="text"
                                            />
                                          </div>
                                        </div>

                                        {/* State */}
                                        <div className="mb-3 row w-50"></div>
                                        <div className="modal-footer bg-transparent">
                                          <button
                                            type="button"
                                            className="btn me-auto disable"
                                            data-bs-dismiss="modal"
                                          >
                                            Close
                                          </button>
                                          <div className="btn-list justify-content-center">
                                            <button
                                              className="btn btn-primary"
                                              data-bs-dismiss="modal"
                                              onClick={() =>
                                                handelSubmit(props.values)
                                              }
                                            >
                                              Order Item
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Form>
                              )}
                            </Formik>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="row row-deck">
                  {console.log(plantData)}
                  {plantData?.map((item) => (
                    <div className="col-md-4 col-6 mb-4" key={item?.id}>
                      <div className="card h-100 d-flex flex-column">
                        <div className="text-center mt-3">
                          <img
                            src={`${item?.agronomyWikiUpdate?.image}`}
                            className="me-3"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                            }}
                            alt="Item"
                          />
                          <h3 className="mt-3 mb-0">
                            {item?.agronomyWikiUpdate?.name}
                          </h3>
                          <p className=" text-muted mb-0">{item?.plantSKU}</p>
                        </div>
                        <div className="card-body d-flex flex-column mt-0">
                          <p className="card-title fw-bold text-center">
                            Price:{" "}
                            <span style={{ color: "rgb(12, 131, 31)" }}>
                              {roundOffCost(
                                item?.agronomyWikiUpdate?.plantPriceForFarmer
                              )}
                            </span>
                          </p>
                          {/* <p
                            className="card-title fw-bold text-center"
                            style={{ color: "rgb(12, 131, 31)" }}
                          >
                            Price For Customer:{" "}
                            <span style={{ color: "rgb(12, 131, 31)" }}>
                              {roundOffCost(
                                item?.agronomyWikiUpdate?.plantPriceForCustomer
                              )}
                            </span>
                          </p> */}

                          <div className="mt-auto">
                            <button
                              className="btn w-100 btn-success"
                              style={{
                                borderRadius: "8px",
                                fontWeight: "bold",
                                fontSize: "16px",
                              }}
                              data-bs-toggle="modal"
                              data-bs-target={`#modal-${item.id}`}
                              onClick={() => handleOrderPlants(item)}
                            >
                              Order Now
                            </button>
                          </div>
                          <div
                            className="modal modal-blur fade"
                            id={`modal-${item.id}`}
                            tabIndex="-1"
                            role="dialog"
                            aria-hidden="true"
                          >
                            <Formik
                              initialValues={{
                                ...CnFShopInfo,
                                productId: item.id,
                                accId: null,
                              }}
                              validationSchema={CreateFarmerOrder}
                              onSubmit={handelSubmit}
                              enableReinitialize
                            >
                              {(props) => (
                                <Form className="modal-dialog modal-dialog-centered w-lg-100 w-md-100">
                                  <div
                                    className="modal-dialog modal-dialog-centered w-100"
                                    role="document"
                                  >
                                    <div className="modal-content">
                                      <div className="modal-header">
                                        <h5 className="modal-title">Order</h5>
                                        <button
                                          type="button"
                                          className="btn-close"
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                        ></button>
                                      </div>
                                      <div className="modal-body">
                                        {/* Quantity */}
                                        <div className="mb-3 row d-flex">
                                          <div className="mb-3 w-50">
                                            <label className="form-label required">
                                              Quantity
                                            </label>
                                            <div className="w-100 col">
                                              <CustomInput
                                                name="quantity"
                                                type="text"
                                                onChange={(e) =>
                                                  handleQuantityChange(
                                                    e.target.value,
                                                    props.setFieldValue,
                                                    item?.agronomyWikiUpdate
                                                      ?.plantPriceForFarmer
                                                  )
                                                }
                                              />
                                              {props.touched.quantity &&
                                                props.errors.quantity && (
                                                  <p className="text-danger">
                                                    {props.errors.quantity}
                                                  </p>
                                                )}
                                            </div>
                                          </div>
                                          <div className="mb-3 w-50">
                                            <label className="form-label required">
                                              Total Amount
                                            </label>
                                            <div className="ms-2 mt-2">
                                              ₹{props.values.totalAmount}
                                            </div>
                                          </div>
                                        </div>
                                        <div className="mb-3 row">
                                          <label className="form-label required">
                                            Select order to
                                          </label>
                                          <div className="w-100 col">
                                            <CustomSelect
                                              name="orderTo"
                                              type="text"
                                              className="form-control"
                                            >
                                              {project && project.length > 0 ? (
                                                <>
                                                  <option value="">
                                                    Select
                                                  </option>
                                                  {project.map((pro) => (
                                                    <option
                                                      key={pro?.id}
                                                      value={pro?.id}
                                                    >
                                                      {pro?.userName} (
                                                      {pro?.inventory?.quantity}{" "}
                                                      - Available)
                                                    </option>
                                                  ))}
                                                </>
                                              ) : (
                                                <option value="">
                                                  No farmer available with this
                                                  item
                                                </option>
                                              )}
                                            </CustomSelect>
                                            {props.touched.orderTo &&
                                              props.errors.orderTo && (
                                                <p className="text-danger">
                                                  {props.errors.orderTo}
                                                </p>
                                              )}
                                          </div>
                                        </div>
                                        <div className="row w-100 d-flex">
                                          <div className="mb-3 w-50">
                                            <label className="form-label required">
                                              Select Address
                                            </label>
                                            <select
                                              className="form-select"
                                              onChange={(e) => {
                                                const selectedAddress =
                                                  addressData.find(
                                                    (addr) =>
                                                      addr.id ===
                                                      parseInt(e.target.value)
                                                  );
                                                if (selectedAddress) {
                                                  // Set the form fields using Formik's setFieldValue
                                                  props.setFieldValue(
                                                    "shippingAddress",
                                                    selectedAddress.shippingAddress
                                                  );
                                                }
                                              }}
                                            >
                                              <option
                                                value=""
                                                label="Select an address"
                                              />
                                              {addressData?.map((address) => (
                                                <option
                                                  key={address.id}
                                                  value={address.id}
                                                >
                                                  {
                                                    address.shippingAddress
                                                      .address
                                                  }
                                                  ,{" "}
                                                  {address.shippingAddress.city}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                          <div className="mb-3 w-50 mt-4">
                                            <button
                                              className="btn btn-primary ms-5"
                                              data-bs-dismiss="modal"
                                              onClick={() =>
                                                navigate("/add-address")
                                              }
                                            >
                                              <IoMdAdd className="me-2" /> Add
                                              Address
                                            </button>
                                            {/* <div
                                              className="modal modal-blur fade"
                                              id="modal-address"
                                              tabindex="-1"
                                              role="dialog"
                                              aria-hidden="true"
                                            >
                                              <div
                                                className="modal-dialog modal-dialog-centered"
                                                role="document"
                                              >
                                                <div className="modal-content">
                                                  <div className="modal-header">
                                                    <h5 className="modal-title">
                                                      Add a new address
                                                    </h5>
                                                    <button
                                                      type="button"
                                                      className="btn-close"
                                                      data-bs-dismiss="modal"
                                                      aria-label="Close"
                                                    ></button>
                                                  </div>
                                                  <div className="modal-body">
                                                    <div className="row mb-3 align-items-end">
                                                      <div className="col">
                                                        <label className="form-label">
                                                          Name
                                                        </label>
                                                        <input
                                                          type="text"
                                                          className="form-control"
                                                        />
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="modal-footer">
                                                    <button
                                                      type="button"
                                                      className="btn me-auto"
                                                      data-bs-dismiss="modal"
                                                    >
                                                      Close
                                                    </button>
                                                    <button
                                                      type="button"
                                                      className="btn btn-primary"
                                                      data-bs-dismiss="modal"
                                                    >
                                                      Add Team
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div> */}
                                          </div>
                                        </div>
                                        <div className="mb-3 row">
                                          <label className="form-label required">
                                            Address
                                          </label>
                                          <CustomTextArea
                                            name="shippingAddress.address"
                                            type="text"
                                          />
                                        </div>
                                        {/* Address  */}
                                        <div className="mb-3 row">
                                          <label className="form-label required">
                                            Select City
                                          </label>
                                          <select
                                            name="shippingAddress.city"
                                            className="form-select"
                                            value={
                                              props.values.shippingAddress.city
                                            }
                                            onChange={(e) => {
                                              handleCityChange(
                                                e.target.value,
                                                props.setFieldValue
                                              );
                                            }}
                                          >
                                            <option
                                              value=""
                                              label="Select city"
                                            />
                                            {city?.allCityData?.map((item) => (
                                              <option
                                                key={item.id}
                                                value={item.city}
                                              >
                                                {item.city}
                                              </option>
                                            ))}
                                          </select>
                                          {props.errors.shippingAddress
                                            ?.city && (
                                            <p className="text-danger">
                                              {
                                                props.errors.shippingAddress
                                                  .city
                                              }
                                            </p>
                                          )}
                                        </div>

                                        {/* Pincode */}
                                        <div className="mb-3 row w-100 d-flex">
                                          <div className="mb-3 w-50">
                                            <label className="form-label required">
                                              Pincode
                                            </label>
                                            <CustomInput
                                              name="shippingAddress.pincode"
                                              type="text"
                                            />
                                          </div>
                                          <div className="mb-3 w-50">
                                            <label className="form-label required">
                                              State
                                            </label>
                                            <CustomInput
                                              name="shippingAddress.state"
                                              type="text"
                                            />
                                          </div>
                                        </div>

                                        {/* State */}
                                        <div className="mb-3 row w-50"></div>
                                        <div className="modal-footer bg-transparent">
                                          <button
                                            type="button"
                                            className="btn me-auto disable"
                                            data-bs-dismiss="modal"
                                          >
                                            Close
                                          </button>
                                          <div className="btn-list justify-content-center">
                                            <button
                                              className="btn btn-primary"
                                              data-bs-dismiss="modal"
                                              onClick={() =>
                                                handleOrderPlant(props.values)
                                              }
                                            >
                                              Order Item
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Form>
                              )}
                            </Formik>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CnfShop;
